/*
 *
 *  * Copyright (c) Funtip GbR 2018.
 *  * Simon Oldeboershuis, Perry Prust
 *
 */

import actionCreatorFactory from 'typescript-fsa';
import { Album, Song } from '../../../services/playlist';

const actionCreator = actionCreatorFactory();

export const SONG_LOAD = 'SONG_LOAD';
export const loadSong = actionCreator<string>(SONG_LOAD);

export const SONG_SET = 'SONG_SET';
export const setSong = actionCreator<Song>(SONG_SET);

export const SONG_SAVE = 'SONG_SAVE';
export const saveSong = actionCreator<Song>(SONG_SAVE);

export const SONG_LOAD_ALBUMS = 'SONG_LOAD_ALBUMS';
export const songLoadAlbums = actionCreator<string>(SONG_LOAD_ALBUMS);

export const SONG_SET_ALBUMS = 'SONG_SET_ALBUMS';
export const songSetAlbums = actionCreator<Album[]>(SONG_SET_ALBUMS);
